var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"donate-embed",class:{ small: _vm.isSmall }},[_c('div',{staticClass:"btn btn-primary",class:_vm.clickable,attrs:{"name":"button"},on:{"click":_vm.donate}},[_c('b',[_vm._v(_vm._s(_vm.btntitle || 'Donate Ether'))]),_vm._v(" "),_c('sub',[_vm._v(_vm._s(_vm.address))])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-d3fe007e","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/DonateButton.vue
// module id = null
// module chunks = 